import { CSSProperties, FC, PropsWithChildren, useCallback } from 'react';

import { styled } from '../../theme';
import { Size } from '../../utility/common-props-helpers';
import SvgIcon from '../SvgIcon';
import { useAccordion } from './AccordionGroup';

const SummaryContent = styled('div')`
    width: 100%;
`;

const AccordionSummaryWrapper = styled('div')<{ style?: CSSProperties }>(
    ({ theme, style = {} }) => ({
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        padding: 10,
        borderBottom: theme.border.tableRowSeparator,
        minHeight: 70,
        transition: 'background-color 0.2s ease',

        ':hover': {
            background: theme.color.surface,
            svg: {
                color: theme.color.green1,
            },
        },
        ...style,
    })
);

const StyledIcon = styled(SvgIcon)<{ isOpen: boolean }>(({ isOpen }) => ({
    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.5s ease',
    justifySelf: 'flex-end',
}));

type Props = PropsWithChildren & {
    style?: CSSProperties;
    id: string;
    arrowSize?: Size;
};

const StyledAccordionSummary: FC<Props> = ({ children, style, id, arrowSize = 'lg' }) => {
    const { openedState, toggleOpenedState } = useAccordion();
    const isOpen = openedState.has(id);
    const handleClick = useCallback(() => {
        toggleOpenedState(id);
    }, [id, toggleOpenedState]);

    return (
        <AccordionSummaryWrapper onClick={handleClick} style={style}>
            <SummaryContent>{children}</SummaryContent>
            <StyledIcon src="/icons/ic-arrow-down.svg" size={arrowSize} isOpen={isOpen} />
        </AccordionSummaryWrapper>
    );
};

export default StyledAccordionSummary;
